import React from "react";
import styled from "styled-components";
import { Minus } from "react-feather";
import { SPOTTER_STRINGS } from "./strings";

/** Changes-panel item pill for one value lost from a list (a source, a term, an excluded tag, a
 *  routed FR person) — the red counterpart to `SpotterAddedTag`, matching `RemoveBadge`/`NewBadge`'s
 *  add/remove color convention on `ab-vault/candidate-assignments`' own Changes panel. */
const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 99px;
  white-space: nowrap;
  font-family: ui-monospace, Menlo, monospace;
  background: var(--spotterDangerSoft);
  color: var(--spotterDanger);
  border: 1px solid var(--spotterDangerBorder);
  flex-shrink: 0;
`;

const SpotterRemovedTag = () => (
  <Tag>
    <Minus size={11} />
    {SPOTTER_STRINGS.removedTag}
  </Tag>
);

export default SpotterRemovedTag;
